<arkiv-trevisning [initiellMappeId]="initiellMappeId()" />
